import(/* webpackMode: "eager" */ "/Users/mac/development/web_projects/codigo/wisly/src/app/studio/page.tsx");
